// extracted by mini-css-extract-plugin
module.exports = {"container":"AppInitializeScreen_container__1x6Vv","wrap":"AppInitializeScreen_wrap__uV-XH"};